module.exports = __webpack_public_path__ + "img/es.981ca7d1.png";